
import { injectable } from 'inversify';
import IDateTimeSource from './IDateTimeSource';

@injectable()
export default class DateTimeSource implements IDateTimeSource {
    public DateNow(): Date {
      return new Date();
    }
};